export interface ProjectTemplateCardInput {
  id?: number;
  name?: string;
  description?: string;
  updatedAt?: string;
  createdBy?: {
    name?: string;
  };
  projectTemplateCreatedBy?: {
    name?: string;
  };
}

export interface ProjectTemplateCardData {
  id: number | undefined;
  name: string;
  description: string;
  updatedAt: string | undefined;
  creatorName: string;
}

export function resolveProjectTemplateCreatorName(template: ProjectTemplateCardInput): string {
  return template.createdBy?.name ?? template.projectTemplateCreatedBy?.name ?? 'none';
}

export function normalizeProjectTemplateCard(template: ProjectTemplateCardInput): ProjectTemplateCardData {
  return {
    id: template.id,
    name: template.name ?? 'Untitled template',
    description: template.description ?? '',
    updatedAt: template.updatedAt,
    creatorName: resolveProjectTemplateCreatorName(template),
  };
}
